import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from "../../assets/img/core-img/logo-small.png";

type HomeLogoLinkProps = {
    className?: string;
};

const resolveShopImageUrl = (imagePath?: string | null): string | null => {
    if (!imagePath || typeof imagePath !== "string") {
        return null;
    }

    const normalizedPath = imagePath.trim();
    if (!normalizedPath) {
        return null;
    }

    if (/^(?:https?:)?\/\//.test(normalizedPath) || normalizedPath.startsWith("data:") || normalizedPath.startsWith("blob:")) {
        return normalizedPath;
    }

    const fallbackOrigin = typeof window !== "undefined" ? window.location.origin : "";
    const apiBaseUrl = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");
    const apiOrigin = apiBaseUrl
        ? new URL(apiBaseUrl, fallbackOrigin || "http://localhost").origin
        : fallbackOrigin;
    const cleanedPath = normalizedPath.replace(/^\/+/, "");

    if (cleanedPath.startsWith("uploads/")) {
        return `${apiOrigin}/storage/${cleanedPath}`;
    }

    return `${apiOrigin}/${cleanedPath}`;
};

const HomeLogoLink: React.FC<HomeLogoLinkProps> = ({ className = "" }) => {
    const authUser = useSelector((state: any) => state.auth?.user);
    const shop = authUser?.shop ?? authUser?.ownedShop ?? (Array.isArray(authUser?.shops) ? authUser?.shops?.[0] : null);
    const headerLogo = resolveShopImageUrl(shop?.image || shop?.avatar) || logo;

    return (
        <div className={`logo-wrapper ${className}`.trim()}>
            <Link to="/order">
                <img src={headerLogo} alt={shop?.name ?? "Kiosk"} width="35" height="35" />
            </Link>
        </div>
    );
};

export default HomeLogoLink;
